import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Button, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { revalueAsset } from "../../actions/revaluate";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import API from "../../Api/api";
import { Helmet } from "react-helmet-async";

const columns = [
  { id: "code", label: "Code", minWidth: 100 },
  { id: "asset_pool", label: "Asset Pool", minWidth: 100 },
  {
    id: "original_cost",
    label: "Original Cost",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "accum_deprecation",
    label: "Accum. Depre. ",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "carrying_amount",
    label: "Carrying Amt",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "revalued_amt",
    label: "Revalued Amt",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "surplus_deficit",
    label: "Supplus/Deficit",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "Revaluation",
    label: "Revaluation Date",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
];

function createRevalue(
  code,
  asset_pool,
  original_cost,
  accum_deprecation,
  revalued_amt,
  Revaluation
) {
  const carrying_amount = original_cost * 1 - accum_deprecation * 1;
  const surplus_deficit = revalued_amt * 1 - carrying_amount * 1;

  return {
    code,
    asset_pool,
    original_cost,
    accum_deprecation,
    carrying_amount,
    revalued_amt,
    surplus_deficit,
    Revaluation,
  };
}

function createData(label) {
  return { label };
}

export default function RevalueAsset() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: `${mode === "dark" ? "#ccc" : "#ffffff"}`,
    color: `${mode === "dark" ? "#fff" : "#000"}`,
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = React.useState(false);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const assetsData = useSelector((state) => state.assets);
  const rows = [
    assetsData?.map((data) => {
      return createData(data.code);
    }),
  ];
  const revalued = useSelector((state) => state.revalued);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const [fromDb, setFromDb] = React.useState([]);
  const [revalueData, setRevalueData] = React.useState({
    revaluation_date: "",
    code: "",
    cost: "",
  });
  React.useEffect(() => {
    const fetchData = async () => {
      const res = await API.get(
        `/api/v1/company-assets/ppe/ppe-section?code=${revalueData.code}`
      );
      if (res.data[0]) {
        setFromDb(res.data[0]);
      } else {
        setFromDb([]);
      }
    };
    fetchData();
  }, [revalueData.code]);
  const today = moment(revalueData.revaluation_date);
  const purchase_date = fromDb?.purchase_date;
  const asset_life = fromDb?.asset_life;
  const daily_depreciation = fromDb?.daily_depreciation;
  const diff = today.diff(purchase_date, "days");
  const daysUnExpired = asset_life - diff;
  const new_daily_depreciation = (revalueData.cost * 1) / daysUnExpired;
  const accumulated_depreciation = daily_depreciation * (diff - 1);

  const postData = {
    revaluation_date: revalueData.revaluation_date,
    new_daily_depreciation: new_daily_depreciation,
    revalued_amount: revalueData.cost,
    new_cost: revalueData.cost,
    revalued: "true",
    revalued_by: user.results.firstName + " " + user.results.lastName,
    accumulated_depreciation: accumulated_depreciation,
    approved: "false",
  };

  let options = [];
  assetsData?.map((data) => options.push(data.code));
  const dispatch = useDispatch();
  function sendData() {
    if (fromDb?._id) {
      dispatch(revalueAsset(postData, fromDb._id));
      setRevalueData({
        revaluation_date: "",
        code: "",
        cost: "",
      });
      alert("Asset Revalued");
      handleClose();
    } else {
      return;
    }
  }

  const row2 = revalued
    ? revalued?.map((data) => {
        return createRevalue(
          data.code,
          data.category,
          data.cost,
          data.accumulated_depreciation,
          data.revalued_amount,
          moment(data.revaluation_date).format("YYYY-MM-DD")
        );
      })
    : [];
  let allowManipulate = false;
  if (
    user.results.assets === "Administrator" ||
    user.results.assets === "Read-Write"
  ) {
    allowManipulate = true;
  } else {
    allowManipulate = false;
  }
  return (
    <div style={{ height: "calc(90dvh - 100px)" }}>
      <Helmet>
        <title>Asset Revaluation</title>
      </Helmet>
      <Paper
        sx={{
          width: "100%",
          backgroundColor: `${mode === "dark" ? "#303030" : "#ffffff"}`,
        }}>
        <Modal
          aria-labelledby='transition-modal-title'
          aria-describedby='transition-modal-description'
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}>
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id='transition-modal-title'
                variant='h5'
                component='h2'
                style={{ marginBottom: "15px", color: "#000000" }}>
                Revalue Asset
              </Typography>
              <form style={{ display: "flex", flexDirection: "column" }}>
                <Autocomplete
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disablePortal
                  id='combo-box-demo'
                  options={options}
                  onChange={(e, n) =>
                    setRevalueData({ ...revalueData, code: n })
                  }
                  sx={{ width: 300 }}
                  renderInput={(params) => (
                    <TextField {...params} label='Asset' />
                  )}
                />
                <label style={{ color: "#000000" }} htmlFor='revaluation-date'>
                  Revaluation Date
                </label>
                <TextField
                  id='revaluation-date'
                  style={{ marginBottom: "10px" }}
                  type='date'
                  size='small'
                  value={revalueData.revaluation_date}
                  onChange={(e) =>
                    setRevalueData({
                      ...revalueData,
                      revaluation_date: e.target.value,
                    })
                  }
                  required
                />
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='number'
                  size='small'
                  value={revalueData.cost}
                  onChange={(e) =>
                    setRevalueData({
                      ...revalueData,
                      cost: e.target.value,
                    })
                  }
                  label='new cost'
                  required
                />

                <div>
                  <Button
                    variant='contained'
                    onClick={sendData}
                    size='small'
                    style={{
                      textTransform: "none",
                      margin: "5px",
                      backgroundColor: "#116149",
                    }}>
                    Submit
                  </Button>
                  <Button
                    variant='contained'
                    style={{
                      textTransform: "none",
                      backgroundColor: "#D32F2F",
                    }}
                    onClick={handleClose}
                    size='small'>
                    Cancel
                  </Button>
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>
        <Button
          disabled={!allowManipulate}
          style={{
            textTransform: "capitalize",
            margin: "5px",
            backgroundColor: `${mode === "dark" ? "#0883FF" : "#116149"}`,
          }}
          onClick={handleOpen}
          variant='contained'>
          Revalue Asset
        </Button>
        <em style={{ color: "red" }}>
          {allowManipulate
            ? ""
            : "you don't have the permission to revalue asset"}
        </em>
        <TableContainer sx={{ height: "calc(77dvh - 100px)" }}>
          <Table
            size='small'
            stickyHeader
            aria-label='sticky table'
            style={{
              backgroundColor: `${mode === "dark" ? "#303030" : "#E9F1F7"}`,
              color: `${mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"}`,
            }}
            sx={
              {
                // "& tr > *:last-child": {
                //   position: "sticky",
                //   right: 0,
                //   // bgcolor: "#cccc",
                // },
              }
            }>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#3D4F58",
                      color: `${
                        mode === "dark" ? "rgba(255,255,255,0.65)" : "#ccc"
                      }`,
                    }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {row2
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow
                      hover
                      role='checkbox'
                      tabIndex={-1}
                      key={row.code}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              backgroundColor: `${
                                mode === "dark" ? "#303030" : "#E9F1F7"
                              }`,
                              color: `${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000"
                              }`,
                            }}
                            key={column.id}
                            align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          style={{
            backgroundColor: `${mode === "dark" ? "#303030" : "#E9F1F7"}`,
            color: `${mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"}`,
          }}
          rowsPerPageOptions={[10, 25, 100]}
          component='div'
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
